export { Card as StoresCard } from './card'
